import GithubIcon from "assets/icons/GithubIcon";
import TelegramIcon from "assets/icons/TelegramIcon";
import TwitterIcon from "assets/icons/TwitterIcon";

export const SOCIALS_CONFIG: {
  name: string;
  url: string;
  icon: ({ ...props }: React.SVGProps<SVGSVGElement>) => JSX.Element;
}[] = [
    // {
    //     name: "Github",
    //     url: "https://github.com/NectarProtocol",
    //     icon: GithubIcon,
    // },
    {
      name: "Twitter",
      url: "https://twitter.com/NectarLiquid",
      icon: TwitterIcon,
    },
    // {
    //   name: "Telegram",
    //   url: "https://t.me/NectarProtocol",
    //   icon: TelegramIcon,
    // },
  ];
